<template>
  <b-modal
    centered
    size="lg"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="modern-modal-content">
      <!-- Header -->
      <div class="modern-modal-header">
        <div class="modern-modal-icon-wrapper">
          <v-icon name="file-export" scale="1.5"></v-icon>
        </div>
        <h3 class="modern-modal-title">{{ $t("globals.export_exact") }}</h3>
        <p class="modern-modal-description">{{ $t('globals.select_export_option') }}</p>
      </div>

      <!-- Tabs -->
      <div class="modern-modal-form-section">
        <b-tabs vertical pills card>
          <b-tab :title="$t('globals.invoices')">
            <b-tabs>
              <b-tab :title="$t('globals.date_range')">
                <div class="tab-content-wrapper">
                  <label class="modern-modal-label">{{ $t('globals.date_range') }}</label>
                  <ulu-date-picker
                    range
                    v-model="dateRange"
                    lang="en"
                    format="DD.MM.YYYY"
                    :placeholder="$t('globals.select_range')"
                    class="modern-modal-date-picker"
                  />
                  <div class="modern-modal-actions">
                    <b-btn
                      @click="cancelModal"
                      class="modern-modal-btn modern-modal-btn-cancel"
                    >
                      <v-icon name="times" scale="0.9"></v-icon>
                      {{ $t("globals.cancel") }}
                    </b-btn>
                    <b-btn
                      @click="dateDownload"
                      :disabled="dateDownloadDisabled"
                      class="modern-modal-btn modern-modal-btn-success"
                    >
                      <v-icon name="download" scale="0.9"></v-icon>
                      {{ $t("globals.download") }}
                    </b-btn>
                  </div>
                </div>
              </b-tab>
              <b-tab :title="$t('globals.from_invoice_no')">
                <div class="tab-content-wrapper">
                  <label class="modern-modal-label">{{ $t('globals.from_invoice_no') }}</label>
                  <b-input
                    v-model="invoice_no"
                    type="text"
                    :placeholder="$t('globals.from_invoice_no')"
                    class="modern-modal-input"
                  />
                  <div class="modern-modal-actions">
                    <b-btn
                      @click="cancelModal"
                      class="modern-modal-btn modern-modal-btn-cancel"
                    >
                      <v-icon name="times" scale="0.9"></v-icon>
                      {{ $t("globals.cancel") }}
                    </b-btn>
                    <b-btn
                      @click="fromLastInvoiceDownload"
                      :disabled="invoice_no.length == 0"
                      class="modern-modal-btn modern-modal-btn-success"
                    >
                      <v-icon name="download" scale="0.9"></v-icon>
                      {{ $t("globals.download") }}
                    </b-btn>
                  </div>
                </div>
              </b-tab>
              <b-tab :title="$t('globals.from_debiteur_no')">
                <div class="tab-content-wrapper">
                  <label class="modern-modal-label">{{ $t('globals.from_debiteur_no') }}</label>
                  <b-input
                    v-model="from_debiteur_no"
                    :placeholder="$t('globals.from_debiteur_no')"
                    type="text"
                    class="modern-modal-input"
                  />
                  <div class="modern-modal-actions">
                    <b-btn
                      @click="cancelModal"
                      class="modern-modal-btn modern-modal-btn-cancel"
                    >
                      <v-icon name="times" scale="0.9"></v-icon>
                      {{ $t("globals.cancel") }}
                    </b-btn>
                    <b-btn
                      @click="newDownload"
                      :disabled="from_debiteur_no.length == 0"
                      class="modern-modal-btn modern-modal-btn-success"
                    >
                      <v-icon name="download" scale="0.9"></v-icon>
                      {{ $t("globals.download") }}
                    </b-btn>
                  </div>
                </div>
              </b-tab>
              <b-tab :title="$t('globals.debiteur_no')">
                <div class="tab-content-wrapper">
                  <label class="modern-modal-label">{{ $t('globals.debiteur_no') }}</label>
                  <b-input
                    v-model="debiteur_no"
                    type="text"
                    :placeholder="$t('globals.debiteur_no')"
                    class="modern-modal-input"
                  />
                  <div class="modern-modal-actions">
                    <b-btn
                      @click="cancelModal"
                      class="modern-modal-btn modern-modal-btn-cancel"
                    >
                      <v-icon name="times" scale="0.9"></v-icon>
                      {{ $t("globals.cancel") }}
                    </b-btn>
                    <b-btn
                      @click="debiteurDownload"
                      :disabled="debiteur_no.length == 0"
                      class="modern-modal-btn modern-modal-btn-success"
                    >
                      <v-icon name="download" scale="0.9"></v-icon>
                      {{ $t("globals.download") }}
                    </b-btn>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-tab>
          <b-tab :title="$t('globals.parking_invoices')">
            <div class="tab-content-wrapper">
              <label class="modern-modal-label">{{ $t('globals.select_month') }}</label>
              <ulu-date-picker
                type="month"
                v-model="parkingDate"
                lang="en"
                format="MM.YYYY"
                :placeholder="$t('globals.select_month')"
                class="modern-modal-date-picker"
              />
              <div class="modern-modal-actions">
                <b-btn
                  @click="cancelModal"
                  class="modern-modal-btn modern-modal-btn-cancel"
                >
                  <v-icon name="times" scale="0.9"></v-icon>
                  {{ $t("globals.cancel") }}
                </b-btn>
                <b-btn
                  @click="parkingDownload"
                  :disabled="parkingDownloadDisabled"
                  class="modern-modal-btn modern-modal-btn-success"
                >
                  <v-icon name="download" scale="0.9"></v-icon>
                  {{ $t("globals.download") }}
                </b-btn>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";

import "vue-awesome/icons/file-export";
import "vue-awesome/icons/download";
import "vue-awesome/icons/times";

export default {
  components: {
    "ulu-date-picker": DatePicker,
    "v-icon": () => import("vue-awesome/components/Icon.vue")
  },
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      dateRange: [null, null],
      from_debiteur_no: "",
      debiteur_no: "",
      invoice_no: "",
      parkingDate: null
    };
  },
  methods: {
    dateDownload() {
      let from = this.dateRange[0];
      let to = this.dateRange[1];

      from = `${from.getDate()}.${from.getMonth() + 1}.${from.getFullYear()}`;
      to = `${to.getDate()}.${to.getMonth() + 1}.${to.getFullYear()}`;

      window.open(
        `${
          this.getBackendUrl
        }/exact_export?from=${from}&to=${to}&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    fromLastInvoiceDownload() {
      window.open(
        `${this.getBackendUrl}/exact_export?last_invoice_no=${
          this.invoice_no
        }&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    newDownload() {
      window.open(
        `${this.getBackendUrl}/exact_export_customers?debiteur_no_from=${
          this.from_debiteur_no
        }&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    debiteurDownload() {
      window.open(
        `${this.getBackendUrl}/exact_export_customers?debiteur_no_from=${
          this.debiteur_no
        }&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    parkingDownload() {
      let date = `${this.parkingDate.getFullYear()}-${this.parkingDate.getMonth() +
        1}-${this.parkingDate.getDate()}`;

      window.open(
        `${
          this.getBackendUrl
        }/exact_parking_export?date=${date}&brand=${this.getUserSystem.toLowerCase()}`,
        "_blank"
      );
      this.cancelModal();
    },
    cancelModal() {
      this.dateRange = [null, null];
      this.from_debiteur_no = "";
      this.debiteur_no = "";
      this.invoice_no = "";
      this.parkingDate = null;
      this.close();
    }
  },
  computed: {
    ...mapGetters(["getBackendUrl", "getUserSystem"]),
    dateDownloadDisabled() {
      return this.dateRange[0] == null || this.dateRange[1] == null;
    },
    parkingDownloadDisabled() {
      return this.parkingDate == null;
    }
  }
};
</script>

<style scoped>
@import '../../../styles/modal.css';

.tab-content-wrapper {
  padding: 1.5rem;
  min-height: 300px;
}
</style>
